import React from 'react';
import { isNil } from 'lodash';
import { DEFAULT_TAG, prefix } from './flex.constants';
import { FlexProps } from './flex.models';
import { generateFlexClasses } from './flex.utilities';

const defaultProps = {
  tag: DEFAULT_TAG
};

export const FlexItem = (props: FlexProps): JSX.Element => {

  const { tag, iterateKey, children, isRender, id } = props;

  if (!isNil(isRender) && !isRender) {
    return null;
  }

  const flexClasses = generateFlexClasses(props, prefix.ITEM);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  const _children = React.Children.count(children) === 1 && typeof children === 'string' ? <>{children}</> : children;
  const item = React.createElement(tag, { className: flexClasses, key: iterateKey, id }, _children);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {item}
    </>
  );
};

FlexItem.defaultProps = defaultProps;
